module.exports = __webpack_public_path__ + "static/IBMPlexSans-Italic-01b2ce7088838c488aa01033415aabb7.woff2";